import type { FaireProductEntity } from "../../entity_types/product";

export const p_b50iydy1: FaireProductEntity = {
  token: "p_b50iydy1",
  type: "product",
  name: "Beach Baby Cotton Bodysuit - Customizable graphic",
  brandToken: "b_8kumxdqk",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/04b444c5064fd0515b75a9d318103dd4e5d2a05b1e084d6e018524b9f138c056.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/607a3bae841df789897180aaa77ebb0d34aa512935623d5e5056d36e52ec2c6b.png",
    "https://cdn.faire.com/fastly/eab27eb33ac8b59d9da6d110dab91f9171a1622bf571c3767aacdb57966ac62f.png",
    "https://cdn.faire.com/fastly/2fc952e396298eeb8a22e7a71af08f9382f86a54cd7fa7e80556ba6acb1be73c.png",
    "https://cdn.faire.com/fastly/5e382e8689013205f5853ea9221d9906d942f7d7ac10c29449b57f2ab070c4d3.png",
    "https://cdn.faire.com/fastly/96bb44ccca92629fd03ec4311481dc7899d89cb89b6cfc9ab3c79eb62e4f1f98.png",
    "https://cdn.faire.com/fastly/506c32bd8e0352d37c3ff885bc6c4b361e8ffbbba46439a1b81516cbcad0e538.png",
    "https://cdn.faire.com/fastly/7e922094d90d08aab1c096e1a4bd708a339193e55913f66a19f1141a3d9df81c.png",
    "https://cdn.faire.com/fastly/266be30f8359e9b0c40c7ae04ed124a11623eede9ec739799808bd9d6956eb52.png",
    "https://cdn.faire.com/fastly/d69a0446b10f26180a049f5b25d768511a4ab584ee54a369cb848a8b35d91616.png",
  ],
  priceDollars: 12.47,
  description:
    "Are you a coastal or beach shop?  This infant bodysuit is our number one seller for any store near the ocean!  It is fully customizable and many stores add their beach or city name underneath the graphic.  These nautical baby clothing items are must have items and come in several colors.\n\nPrinted on Rabbit Skin infant 5oz. Baby Rib Lap Shoulder Cotton Bodysuit. Plastic snap closure\n\nSizes: New Born, 6M, 12M, 18M, 24M (no 24M on long sleeves)\n\nColors: White, Blue, Yellow, Pink, Heather Grey, Indigo, Natural  (more colors upon request)\n\nFabric: 100% combed ringspun cotton 1x1 baby rib. CPSIA compliant tracking label in side seam.\n\n*Items are silk screen printed with water based ink!  \n\n*Please specify if you'd like an ink color other than black as shown\n\n*We can also print on tees upon request!\n",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:13.106Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
